import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";

export const otherVehiclesBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.other-vehicles', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const sliderDesk = section.querySelector('.other-vehicles__swiper');
    const sliderTabs = section.querySelector('.other-vehicles__tabs')

    const tabs = section.querySelectorAll('.other-vehicles__tabs-item')
    const tabsWrapper = section.querySelector('.other-vehicles__tabs')

    let swiperTabs = null;
    let swiper = null;
    const autoplayDelay = 10000;

    const createSwiper = () => {
        if (swiperTabs !== null) {
            swiperTabs.destroy(true, true);
            swiperTabs = null;
        }

        if (!swiperTabs) {
            swiperTabs = _libs._swiper(sliderTabs, {
                slidesPerView: 'auto',
                freeMode: true,
                spaceBetween: 8,
                autoplay: {
                    pauseOnMouseEnter: true,
                    delay: autoplayDelay,
                },
            });
        }

        if (swiper !== null) {
            swiper.destroy(true, true);
            swiper = null;
        }

        if (!swiper) {
            swiper = _libs._swiper(sliderDesk, {
                slidesPerView: 1,
                speed: 800,
                spaceBetween: 16,
                keyboard: {
                    enabled: true,
                },

                // autoHeight: true,

                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },

                breakpoints: {
                    1025: {
                        slidesPerView: 1,
                    },
                    1280: {
                        slidesPerView: 1.33,
                    }
                },
                on: {
                    init: function (s) {
                        tabs.forEach(t => t.classList.remove('active'));
                        const activeTab = tabs[s.activeIndex];
                        activeTab.classList.add('active');
                    },
                },
            });
            swiper.on('slideChange', function (s) {
                tabs.forEach(t => t.classList.remove('active'));
                const activeTab = tabs[s.activeIndex];
                activeTab.classList.add('active');
            });
            swiper.on('autoplayTimeLeft', (s, time, progress) => {
                const active = s.activeIndex;
                const percent = (1 - progress) * 100;

                tabs.forEach((tab, i) => {
                    tab.style.setProperty('--progress', i === active ? `${percent}%` : '0%');
                });
            });
        }

        if (swiper && swiperTabs) {
            swiper.controller.control = swiperTabs;
        }
    }

    const tabsHandler = ()=> {
        tabs?.forEach((tab,index)=> {
            tab.addEventListener('click',()=> {
                tabs?.forEach((tab)=> {
                    tab.classList.remove('active')
                })
                tab.classList.add('active')
                swiper.slideTo(index)
            })
        })
    }

    createSwiper();
    tabsHandler();

    const rebuildFunc = () => {
        if(viewportChecker.all()){
            createSwiper();
            tabsHandler();
        }
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}